import React from "react";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { UserType } from "../../../data/enums";

interface LandingBusinessesProps {
  redirect: (path: string) => void;
}
function LandingBusinesses({ redirect }: LandingBusinessesProps) {
  return (
    <div className="landing-businesses">
      <Typography variant="h2" component="h2" id="landing-businesses-h" className="landing-title">
        Mr. Gen para empresas
      </Typography>
      <div className="landing-businesses-body">
        <Button
          id="landing-business-button-mobile"
          color="primary"
          variant="contained"
          onClick={() => redirect("/signup?user=3")}
          disableElevation
        >
          Quiero saber más
        </Button>
        <div className="landing-businesses-decoration">
          <div id="landing-businesses-image" className="landing-square-image" />
          <div id="landing-businesses-donut" />
        </div>
        <div className="landing-businesses-info">
          <Typography variant="body1" component="p" className="landing-p">
          El programa tiene por objetivo mejorar la salud y calidad de vida de los ejecutivos y colaboradores de la organización, a través de la
generación de hábitos alimenticios proporcionando una dieta totalmente personalizada.
          </Typography>
          <Button
            id="landing-business-button-desktop"
            color="primary"
            variant="contained"
            onClick={() => redirect(`/signup?user=${UserType.Company}`)}
            disableElevation
          >
            Quiero saber más
          </Button>
        </div>
      </div>
    </div>
  );
}

export default LandingBusinesses;
